import { ProductApi, SubstanceApi } from '@core/api'
import SubstanceListReferenceGraph from '@core/domain/substance/SubstanceListReferenceGraph'
import {
    buildCategoryTreeIndex,
    buildSubstanceListVisibilityProductContext,
} from '@core/domain/substance/SubstanceListVisibilityContext'

export default {
    data() {
        return {
            substanceListReferenceGraph: null,
            substanceListVisibilityCategoriesPromise: null,
            materialCategoryTrees: [],
            mixtureCategoryTrees: [],
            categoryTreeIndexes: {
                material_category: {
                    ancestorsById: {},
                    descendantsById: {},
                },
                mixture_category: {
                    ancestorsById: {},
                    descendantsById: {},
                },
            },
        }
    },
    methods: {
        loadSubstanceListVisibilityCategories() {
            if (this.substanceListVisibilityCategoriesPromise) {
                return this.substanceListVisibilityCategoriesPromise
            }

            this.substanceListVisibilityCategoriesPromise = Promise
                .all([
                    SubstanceApi.materialCategories(),
                    ProductApi.mixtureCategories(),
                ])
                .then(([materialCategoriesResponse, mixtureCategoriesResponse]) => {
                    this.materialCategoryTrees = materialCategoriesResponse.data || []
                    this.mixtureCategoryTrees = mixtureCategoriesResponse.data || []
                    this.categoryTreeIndexes = {
                        material_category: this.buildCategoryTreeIndex(this.materialCategoryTrees),
                        mixture_category: this.buildCategoryTreeIndex(this.mixtureCategoryTrees),
                    }
                })

            return this.substanceListVisibilityCategoriesPromise
        },
        buildCategoryTreeIndex(trees) {
            return buildCategoryTreeIndex(trees)
        },
        buildSubstanceListVisibilityProductContext() {
            return buildSubstanceListVisibilityProductContext(
                this.product || {},
                this.materialCategoryTrees,
                this.mixtureCategoryTrees,
            )
        },
        createSubstanceListCategoryMatcher() {
            return ({
                type,
                selectedId,
                ruleId,
                match,
            }) => {
                const categoryIndex = this.categoryTreeIndexes[type] || {}
                const ancestorsById = categoryIndex.ancestorsById || {}

                if (match === 'self_or_descendant') {
                    return (ancestorsById[selectedId] || []).includes(Number(ruleId))
                }

                if (match === 'self_or_ancestor') {
                    return (ancestorsById[ruleId] || []).includes(Number(selectedId))
                }

                return false
            }
        },
        createSubstanceListReferenceGraph(lists) {
            this.substanceListReferenceGraph = new SubstanceListReferenceGraph(lists, {
                categoryMatcher: this.createSubstanceListCategoryMatcher(),
            })

            return this.substanceListReferenceGraph
        },
    },
}
